var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18V19C0 20.1046 0.895431 21 2 21H22C23.1046 21 24 20.1046 24 19V18H0Z",
    fill: "#EBAA3E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 24,
    height: 12,
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90288 15.3501H5.2057L3.93302 10.3852C3.87261 10.1568 3.74435 9.95487 3.55568 9.85971C3.08484 9.62057 2.566 9.43024 2 9.33426V9.14311H4.73403C5.11136 9.14311 5.39436 9.43024 5.44153 9.76372L6.10187 13.3451L7.79822 9.14311H9.44824L6.90288 15.3501ZM10.3916 15.3501H8.78873L10.1086 9.14311H11.7114L10.3916 15.3501ZM13.7851 10.8627C13.8323 10.5284 14.1153 10.3372 14.4454 10.3372C14.9643 10.2892 15.5294 10.3852 16.0011 10.6235L16.2841 9.28714C15.8124 9.09599 15.2936 9 14.8228 9C13.2671 9 12.1351 9.85976 12.1351 11.053C12.1351 11.9608 12.9369 12.4374 13.5029 12.7245C14.1153 13.0108 14.3511 13.202 14.3039 13.4883C14.3039 13.9178 13.8323 14.1089 13.3614 14.1089C12.7954 14.1089 12.2294 13.9658 11.7114 13.7266L11.4284 15.0638C11.9944 15.3022 12.6068 15.3982 13.1728 15.3982C14.9171 15.4453 16.0011 14.5864 16.0011 13.2972C16.0011 11.6736 13.7851 11.5785 13.7851 10.8627ZM21.6107 15.3501L20.338 9.14311H18.971C18.688 9.14311 18.405 9.33426 18.3107 9.62057L15.954 15.3501H17.604L17.9333 14.4432H19.9607L20.1493 15.3501H21.6107ZM19.2068 10.8147L19.6777 13.154H18.3578L19.2068 10.8147Z",
    fill: "#575DC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3C0.89543 3 0 3.89543 0 5V6H24V5C24 3.89543 23.1046 3 22 3H2Z",
    fill: "#575DC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e600b151887b24285fdf7f747d596a32.svg";
export { ForwardRef as ReactComponent };